import React, { type ReactNode } from 'react';

import { DropdownItem, type DropdownItemProps } from '@atlaskit/dropdown-menu';
import type { AnyEntryPoint } from '@atlassian/entry-point-types';

import { ModalTrigger, type Props as ModalTriggerProps } from './ModalTrigger';

export type Props<TEntryPoint> = Omit<ModalTriggerProps<TEntryPoint>, 'children' | 'title'> & {
	modalTitle?: ReactNode;
} & Omit<DropdownItemProps, 'ref'>; // Prevent ref prop collision between ButtonProps and render prop

export const ModalDropdownItemTrigger = <TEntryPoint extends AnyEntryPoint>({
	children,
	entryPoint,
	entryPointParams,
	entryPointProps,
	Fallback,
	modalTitle,
	modalProps,
	forwardedRef,
	preloadOnFocus,
	...dropdownProps
}: Props<TEntryPoint>) => {
	return (
		<ModalTrigger
			forwardedRef={forwardedRef}
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			entryPointProps={entryPointProps}
			Fallback={Fallback}
			title={modalTitle}
			modalProps={modalProps}
			preloadOnFocus={preloadOnFocus}
		>
			{({ ref }) => (
				<DropdownItem ref={ref} {...dropdownProps}>
					{children}
				</DropdownItem>
			)}
		</ModalTrigger>
	);
};
